import {
  AvatarInitials,
  Banner,
  BannerBrandInline,
  BannerBrandLogo,
  BannerBrandSuite,
  BannerRight,
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
  Fishbowl,
} from '@wk/components-react16';
import CsbErrorBoundary from 'components/CsbErrorBoudary/CsbErrorBoundary';
import { useLogout } from 'utils/hooks/auth/useLogout';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import style from './HeaderCsb.module.scss';
import { memo } from 'react';

const HeaderCsb = memo(() => {
  const userInfo = useAppSelector((state: RootState) => state.auth.user);
  const logoutHandler = useLogout();

  const getInitials = (name = 'G'): string => {
    const parts = name.split('@')[0].split('.');
    return parts.map((n) => n[0]).join('');
  };

  return (
    <CsbErrorBoundary>
      <Banner mode="workflow">
        <BannerBrandSuite
          href="#"
          srLabel="Go to Wolters Kluwer Apollo CSB Dashboard home page"
          isPreventDefault
          slot="bannerBrandSuite"
        >
          <BannerBrandLogo slot="bannerBrandLogo"></BannerBrandLogo>
          <BannerBrandInline
            productName="Apollo CSB Dashboard"
            slot="bannerBrand"
          ></BannerBrandInline>
        </BannerBrandSuite>

        <BannerRight slot="bannerRight">
          <div
            id="fishbowlWrapper"
            data-testid="HeaderCsb"
            className={style['fishbowl-wrapper']}
          >
            <Fishbowl
              tooltipPlacementOptions={{ positions: ['left'] }}
              userName={userInfo?.email || ''}
              organizationName={userInfo?.userRole?.name}
              organizationInitials={
                getInitials(userInfo?.userRole?.businessUnit) || 'W'
              }
            >
              <AvatarInitials
                initials={getInitials(userInfo?.email)}
              ></AvatarInitials>
            </Fishbowl>
          </div>
          <Dropdown
            targetSelector="#fishbowlWrapper"
            placementOptions={{ positions: ['bottom-left'] }}
          >
            <DropdownMenu>
              <DropdownMenuItem onItemClick={() => logoutHandler()}>
                Logout
              </DropdownMenuItem>
            </DropdownMenu>
          </Dropdown>
        </BannerRight>
      </Banner>
    </CsbErrorBoundary>
  );
});

export default HeaderCsb;
